module.exports = __webpack_public_path__ + "assets/videos/solar-eclipse-header.mp4?v=9d909cc8";